export default __webpack_public_path__ + "static/media/suco.7c59698b.jpg";